import { render, staticRenderFns } from "./NegociacaoCliente.vue?vue&type=template&id=0a351f07"
import script from "./NegociacaoCliente.vue?vue&type=script&lang=js"
export * from "./NegociacaoCliente.vue?vue&type=script&lang=js"
import style0 from "./NegociacaoCliente.vue?vue&type=style&index=0&id=0a351f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports